const loadedFontFamilies = new Set<string>(['Acme', 'Karla'])

const getFontFamilyName = (fontFamily: string): string => {
  const family = fontFamily.split(',')[0]?.trim() ?? ''
  return family.replace(/^['"]|['"]$/g, '')
}

export const loadGoogleFonts = (fontFamilies: string[]): void => {
  const families = [...new Set(fontFamilies
    .map(getFontFamilyName)
    .filter(family => family && family !== 'Roboto'))]
    .filter(family => !loadedFontFamilies.has(family))

  if (!families.length) return

  families.forEach(family => loadedFontFamilies.add(family))

  const params = families
    .map(family => `family=${encodeURIComponent(family)}:wght@400;600;700`)
    .join('&')
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = `https://fonts.googleapis.com/css2?${params}&display=swap`
  document.head.appendChild(link)
}